import { instance as axiosToken, setJwtToken, setMultiPartHeader } from "../../config/axiosInstance";
import { instance as axios } from "../../config/axiosInstance";

export const getNotificationApi = async (data) => {
    const endPoint = `user/setting/notification/list` + '?' + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken)
}